package dairy.mynotes.reusablecomponents

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Logout
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun LogoutIcon(
    modifier: Modifier,
    contentDescription: String
) {
    Icon(
        imageVector = Icons.AutoMirrored.Filled.Logout,
        contentDescription = contentDescription,
        modifier = modifier
    )
}
